module.exports = new __parcel__URL__("pase-pro.ad90369a.png").toString();